<template>
  <v-footer
    color="blue-grey"
    class="white--text"
    app
  >
    <span>NTT DATA Italia &copy;</span>
    <v-spacer />
    <span>{{ new Date().getFullYear() }}</span>
  </v-footer>
</template>

<script>
export default {
    name: "AppFooter",
};

</script>

<style scoped>

</style>

